// Ловит необработанные ошибки на клиенте (Vue-рендер, window.onerror,
// unhandledrejection) и шлёт их на бэкенд (/api/client-errors), который пишет их в лог
// так же, как серверные ошибки (см. server/src/index.ts, notifyServerError). Цель — получить реальный стек в следующий раз, когда где-то
// вылетит "Cannot read properties of undefined" и т.п., вместо гадания по логам.
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  function report(message: string, stack?: string) {
    try {
      fetch(`${config.public.apiBase}/client-errors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          message,
          stack,
          url: window.location.href,
          userAgent: navigator.userAgent,
        }),
      }).catch(() => { /* сама отправка не должна ронять приложение */ })
    } catch { /* ignore */ }
  }

  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    const error = err instanceof Error ? err : new Error(String(err))
    report(`[vue] ${error.message} (${info})`, error.stack)
    console.error(error)
  }

  window.addEventListener('error', (event) => {
    if (event.error instanceof Error) {
      report(`[window] ${event.error.message}`, event.error.stack)
    } else if (event.message) {
      report(`[window] ${event.message} at ${event.filename}:${event.lineno}:${event.colno}`)
    }
  })

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    if (reason instanceof Error) {
      report(`[unhandledrejection] ${reason.message}`, reason.stack)
    } else {
      report(`[unhandledrejection] ${String(reason)}`)
    }
  })
})
